import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

import { MovieTypesEnum } from '@/constants/movie-types-enum';

type MoviesTypeState = {
  moviesType: MovieTypesEnum;
};

const initState: MoviesTypeState = {
  moviesType: null,
};

export const useMoviesType = createStore({
  name: 'moviesType',
  devtools: isDevtoolsEnabled,
  persist: true,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setMoviesType: handler('moviesType'),
  };
});
